module.exports = __webpack_public_path__ + "static/img/5bg_6.03b1b70.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/5bg_6.png
// module id = 731
// module chunks = 1